<div class="atn-ds-initial-state">
  <div class="atn-ds-initial-state__image-container">
    <img
      [src]="sceneImageUrlSg()"
      class="atn-ds-initial-state__image-content"
    />
  </div>
  <div class="atn-ds-initial-state__app-content">
    <div class="atn-ds-initial-state__app-title">
      {{ appTitleSg() }}
    </div>
    <div class="atn-ds-initial-state__app-description">
      {{ appDescriptionSg() }}
    </div>

    <div class="atn-ds-initial-state__app-image-container">
      <img
        [src]="graphicImageUrlSg()"
        class="atn-ds-initial-state__app-image-content"
      />
    </div>

    <!-- NOTE: if action is not observed, we don't want to show create button -->
    @if (action.observed) {
      <div class="atn-ds-initial-state__button-description">
        {{ btnDescriptionSg() }}
      </div>

      <div class="atn-ds-initial-state__button">
        <atn-ds-button (click)="action.emit()">{{ btnTextSg() }}</atn-ds-button>
      </div>
    }
  </div>
</div>
